export enum DIALOG_TYPES {
  ADD_ADMINISTRATOR,
  REMOVE_ADMINISTRATOR,
  RESEND_INVITATION,
  DELETE_INVITATION,
  RESEND_OWNERSHIP_INVITATION,
  DELETE_OWNERSHIP_INVITATION,
  CHANGE_ORGANIZATION_OWNER
}
